<template>
	<div class="tw-flex-1 tw-max-w-full" id="event-show">
		<modal v-if="popup_open && popup_name === 'save_date'" modal_name="save_date" type="medium" :title="$t('events.add_to_calendar')" icon="calendar-alt" class="tw-relative">
			<template v-slot:modal-content>
				<div class="tw-flex tw-items-start">
					<a :href="eventDateGoogle" class="subtle-button tw-w-1/3 tw-border tw-border-gray-0 tw-px-3 tw-py-2 tw-mr-2 tw-rounded tw-flex tw-items-center tw-justify-center" target="_blank">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="52 42 88 66" height="18" width="18">
							<path fill="#4285f4" d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"/>
							<path fill="#34a853" d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"/>
							<path fill="#fbbc04" d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"/>
							<path fill="#ea4335" d="M72 74V48l24 18 24-18v26L96 92"/>
							<path fill="#c5221f" d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"/>
						</svg>
						<span class="tw-ml-2" v-text="'Google'"></span>
					</a>
					<a :href="eventDateOutlook" class="subtle-button tw-w-1/3 tw-border tw-border-gray-0 tw-px-3 tw-py-2 tw-mr-2 tw-flex tw-items-center tw-justify-center" target="_blank">
						<svg viewBox="-0.12979372698077785 0 33.25199671942124 32" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
							<path d="M28.596 2H11.404A1.404 1.404 0 0 0 10 3.404V5l9.69 3L30 5V3.404A1.404 1.404 0 0 0 28.596 2z" fill="#0364b8"/>
							<path d="M31.65 17.405A11.341 11.341 0 0 0 32 16a.666.666 0 0 0-.333-.576l-.013-.008-.004-.002L20.812 9.24a1.499 1.499 0 0 0-.145-.083 1.5 1.5 0 0 0-1.334 0 1.49 1.49 0 0 0-.145.082L8.35 15.415l-.004.002-.012.007A.666.666 0 0 0 8 16a11.344 11.344 0 0 0 .35 1.405l11.492 8.405z" fill="#0a2767"/><path d="M24 5h-7l-2.021 3L17 11l7 6h6v-6z" fill="#28a8ea"/><path d="M10 5h7v6h-7z" fill="#0078d4"/><path d="M24 5h6v6h-6z" fill="#50d9ff"/><path d="M24 17l-7-6h-7v6l7 6 10.832 1.768z" fill="#0364b8"/><path d="M10.031 5H30" fill="none"/><path d="M17 11h7v6h-7z" fill="#0078d4"/><path d="M10 17h7v6h-7z" fill="#064a8c"/><path d="M24 17h6v6h-6z" fill="#0078d4"/><path d="M20.19 25.218l-11.793-8.6.495-.87s10.745 6.12 10.909 6.212a.528.528 0 0 0 .42-.012l10.933-6.23.496.869z" fill="#0a2767" opacity=".5"/><path d="M31.667 16.577l-.014.008-.003.002-10.838 6.174a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5V16a.666.666 0 0 1-.333.577z" fill="#1490df"/><path d="M32 28.5v-.738l-9.983-5.688-1.205.687a1.497 1.497 0 0 1-1.46.091l3.774 5.061 8.254 1.797v.004A1.498 1.498 0 0 0 32 28.5z" opacity=".05"/><path d="M31.95 28.883L21.007 22.65l-.195.11a1.497 1.497 0 0 1-1.46.092l3.774 5.061 8.254 1.797v.004a1.501 1.501 0 0 0 .57-.83z" opacity=".1"/><path d="M8.35 16.59v-.01h-.01l-.03-.02A.65.65 0 0 1 8 16v12.5A1.498 1.498 0 0 0 9.5 30h21a1.503 1.503 0 0 0 .37-.05.637.637 0 0 0 .18-.06.142.142 0 0 0 .06-.02 1.048 1.048 0 0 0 .23-.13c.02-.01.03-.01.04-.03z" fill="#28a8ea"/><path d="M18 24.667V8.333A1.337 1.337 0 0 0 16.667 7H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 26h8.667A1.337 1.337 0 0 0 18 24.667z" opacity=".1"/><path d="M17 25.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 27h7.667A1.337 1.337 0 0 0 17 25.667z" opacity=".2"/><path d="M17 23.667V9.333A1.337 1.337 0 0 0 15.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h7.667A1.337 1.337 0 0 0 17 23.667z" opacity=".2"/><path d="M16 23.667V9.333A1.337 1.337 0 0 0 14.667 8H10.03V14.456l-1.68.958-.005.002-.012.007A.666.666 0 0 0 8 16v.005V16 25h6.667A1.337 1.337 0 0 0 16 23.667z" opacity=".2"/><path d="M1.333 8h13.334A1.333 1.333 0 0 1 16 9.333v13.334A1.333 1.333 0 0 1 14.667 24H1.333A1.333 1.333 0 0 1 0 22.667V9.333A1.333 1.333 0 0 1 1.333 8z" fill="#0078d4"/><path d="M3.867 13.468a4.181 4.181 0 0 1 1.642-1.814A4.965 4.965 0 0 1 8.119 11a4.617 4.617 0 0 1 2.413.62 4.14 4.14 0 0 1 1.598 1.733 5.597 5.597 0 0 1 .56 2.55 5.901 5.901 0 0 1-.577 2.666 4.239 4.239 0 0 1-1.645 1.794A4.8 4.8 0 0 1 7.963 21a4.729 4.729 0 0 1-2.468-.627 4.204 4.204 0 0 1-1.618-1.736 5.459 5.459 0 0 1-.567-2.519 6.055 6.055 0 0 1 .557-2.65zm1.75 4.258a2.716 2.716 0 0 0 .923 1.194 2.411 2.411 0 0 0 1.443.435 2.533 2.533 0 0 0 1.541-.449 2.603 2.603 0 0 0 .897-1.197 4.626 4.626 0 0 0 .286-1.665 5.063 5.063 0 0 0-.27-1.686 2.669 2.669 0 0 0-.866-1.24 2.387 2.387 0 0 0-1.527-.473 2.493 2.493 0 0 0-1.477.439 2.741 2.741 0 0 0-.944 1.203 4.776 4.776 0 0 0-.007 3.44z" fill="#fff"/><path d="M0 0h32v32H0z" fill="none"/>
						</svg>
						<span class="tw-ml-2" v-text="'Outlook'"></span>
					</a>
					<a :href="`/api/v3/events/${tEvent.id}/calendar`" class="subtle-button tw-w-1/3 tw-border tw-border-gray-0 tw-px-3 tw-py-2 tw-rounded tw-flex tw-items-center tw-justify-center" target="_blank">
						<svg height="17" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 -3.552713678800501e-15 820 950"><path d="M404.345 229.846c52.467 0 98.494-20.488 138.08-61.465s59.38-88.626 59.38-142.947c0-5.966-.472-14.444-1.414-25.434-6.912.942-12.096 1.727-15.552 2.355-48.383 6.908-90.954 30.615-127.713 71.12-36.758 40.506-55.137 83.838-55.137 129.996 0 5.337.785 14.13 2.356 26.375zM592.379 950c37.387 0 78.701-25.59 123.943-76.772S796.122 761.915 820 692.836c-88.912-45.844-133.368-111.626-133.368-197.348 0-71.591 35.973-132.82 107.92-183.688-49.954-62.486-115.931-93.729-197.931-93.729-34.56 0-66.134 5.181-94.724 15.543l-17.908 6.594-24.035 9.42c-15.709 5.966-30.004 8.95-42.885 8.95-10.054 0-23.25-3.455-39.586-10.363l-18.38-7.536-17.436-7.065c-25.449-10.676-52.782-16.014-82-16.014-78.23 0-141.065 26.376-188.506 79.128C23.72 349.479 0 419.03 0 505.379c0 121.517 38.015 233.772 114.046 336.763C166.828 914.047 215.054 950 258.724 950c18.537 0 36.916-3.611 55.138-10.833l23.092-9.42 18.38-6.594c25.762-9.106 49.482-13.659 71.16-13.659 22.935 0 49.326 5.81 79.173 17.427l14.609 5.652C550.75 944.191 574.786 950 592.379 950z"/></svg>
						<span class="tw-ml-2" v-text="'Apple'"></span>
					</a>
				</div>
			</template>
			<template v-slot:modal-bottom>
				<div class="subtle-button slim" @click="closePopup">
					{{ $t('fields.cancel') }}
				</div>
			</template>
		</modal>

		<div class="webinar-card tw-hidden md:tw-block" v-if="show_live_room">
			<room :t-event="tEvent"/>
		</div>

		<event-header :tEvent="tEvent" :apply_live_style="apply_live_header_style" :editing="false" :class="{'tw-block md:tw-hidden': tEvent.type === 'live' && tEvent.live_room.status === 'STARTED'}"></event-header>

		<invite-users-modal :model_id="tEvent.id" endpoint_name="events" v-if="tEvent"></invite-users-modal>

		<modal v-if="popup_open && popup_name === 'leave_event'" modal_name="leave_event" :title="$t('general.warning') + '!'" icon="sign-out-alt">
			<template v-slot:modal-content>
				{{ $t('groups_and_events.are_you_sure_leave') }} {{ $t('groups.cant_be_undone') }}.
			</template>
			<template v-slot:modal-bottom>
				<div class="subtle-button slim" @click="closePopup">
					{{ $t('fields.cancel') }}
				</div>
				<div class="general-button btn-v2 slim leave-button" @click="leave">
					{{ $t('events.leave_event') }}
					<i class="fa fa-sign-out"></i>
				</div>
			</template>
		</modal>

		<modal v-if="popup_open && popup_name === 'disband_event'" modal_name="disband_event" :title="$t('general.warning') + '!'" icon="trash" type="medium">
			<template v-slot:modal-content>
				{{ $t('groups_and_events.are_you_sure_delete') }} {{ $t('groups_and_events.no_one_access') }} {{ $t('events.singular').toLowerCase() }}. {{ $t('groups.cant_be_undone') }}.
			</template>
			<template v-slot:modal-bottom>
				<div class="subtle-button slim" @click="closePopup">
					{{ $t('fields.cancel') }}
				</div>
				<div class="general-button btn-v2 slim leave-button" @click="deleteEvent">
					{{ $t('groups.delete') }} {{ $t('events.singular').toLowerCase() }}
					<i class="fa fa-trash"></i>
				</div>
			</template>
		</modal>

		<modal v-if="popup_open && popup_name === 'get_access'" modal_name="get_access" type="medium" :title="$t('membership.no_access_title')" icon="lock">
			<template v-slot:modal-content>
				<div class="tw-mb-1">
					<p class="light-text" style="margin-bottom: 10px;">{{ $t('membership.no_access_caption') }} </p>

					<p class="light-text">
						{{ $t('membership.does_have_access') }}
						<a href='/auth/login' class='secondary-c bold-text'>{{ $t('membership.click_to_login') }}.</a>
					</p>
				</div>
			</template>
			<template v-slot:modal-bottom>
				<div class="subtle-button slim" @click="closePopup">
					{{ $t('fields.close') }}
				</div>
				<a :href="tEvent.salespage" target="_blank" class="general-button btn-v2 slim">
					{{ $t('membership.get_access') }}
					<i class="fa fa-sign-in"></i>
				</a>
			</template>
		</modal>

        <reminder-modal v-if="mount_reminder_modal" :id="tEvent.id" type="event" @remindersChanged="handleRemindersChanged" @closeMenus="closeReminderMenus"/>

		<tab-menu :sticky-on-scroll="true">
			<template v-if="tEvent">
				<div class="tab-menu-item"
					 v-for="tab in tabs"
					 :key="tab.name_clean"
					 :class="{'tw-cursor-not-allowed': !isMember && tab.name_clean !== '' && tEvent.status !== 'public'}">
					<router-link    :to="{name: 'events.show', params: tab.name_clean !== '' ? { event_slug: tEvent.slug, tab: tab.name_clean } : { event_slug: tEvent.slug }}"
									class="menu-item"
									:class="[
                                {'secondary-c': $route.params.tab === tab.name_clean || (tab.default && typeof $route.params.tab === 'undefined')},
                                {'tw-hidden md:tw-flex': tab.hide_on_mobile},
                                {'disabled': !isMember && tab.name_clean !== '' && tEvent.status !== 'public'}
                            ]">
                        <i :class="tab.icon"></i>
                        {{ tab.name }}
                    </router-link>
                </div>
            </template>
            <template v-slot:sticky>
                <div class="tw-flex tw-flex-col" v-if="tEvent">
                    <h4 v-line-clamp:15="1" v-text="tEvent.title" class="break-normal tw-font-semibold tw-text-lg tw-mb-2"></h4>
                    <div class="tw-hidden tw-items-center tw-text-gray-500 xs:tw-flex">
                        <i class="far fa-calendar-alt tw-pr-2 tw-pt-px"></i>
                        <p class="tw-text-sm">{{ shortDateInfo.startDay }} {{ shortDateInfo.startDate }}
                            <template v-if="!tEvent.all_day">
                                {{ $t('general.time_at') }} {{ shortDateInfo.startTime }}
                            </template>
                            <template v-if="!shortDateInfo.endsOnSameDay">
                                {{ $t('fields.until') }} {{ shortDateInfo.endDay }} {{ shortDateInfo.endDate }}
                                <template v-if="!tEvent.all_day">
                                    {{ $t('general.time_at') }} {{ shortDateInfo.endTime }}
                                </template>
                            </template>
                        </p>
                    </div>
                </div>
            </template>
            <template v-slot:actions v-if="tEvent && tEvent.permissions.includes('VIEW')">
                <div class="action-btn-wrapper">
                    <template v-if="!user">
                        <template v-if="settings['events.public_database'] && tEvent.salespage !== ''">
                            <div class="general-button btn-v2" @click="openPopup('get_access')">
                                {{ $t('events.sign_up') }}
                            </div>
                        </template>
                        <template v-else-if="settings['allow_registration'] && (! settings['hide_registration'])">
                            <a href="/auth/login#register" class="general-button btn-v2">
                                {{ $t('fields.registration') }}
                            </a>
                        </template>
                        <template v-else>
                            <a href="/auth/login#login" class="general-button btn-v2">
                                {{ $t('navigation.login') }}
                            </a>
                        </template>
                    </template>
                    <template v-else-if="tEvent.participation === null || tEvent.participation.status === 'invite_rejected'">
                        <div class="general-button btn-v2" :class="{'tw-opacity-50 tw-pointer-events-none': performing_action}" @click="join">
                            {{ $t('events.participate') }}
                        </div>
                    </template>
                    <template v-else>
                        <template v-if="tEvent.participation.status === 'pending'">
                            <div class="general-button btn-v2 tw-opacity-50 tw-pointer-events-none tw-mr-2">
                                {{ $t('groups.waiting_for_approval') }}
                            </div>
                            <div class="subtle-button slim tw-mr-2" :class="{'tw-opacity-50 tw-pointer-events-none': performing_action}" @click="leave">
                                {{ $t('groups.decline_request') }}
                            </div>
                        </template>
                        <template v-else-if="tEvent.participation.status === 'rejected'">
                            <div class="general-button btn-v2 tw-opacity-50 tw-pointer-events-none">
                                {{ $t('groups.join_request_rejected') }}
                                <i class="far fa-times"></i>
                            </div>
                        </template>
                        <template v-else-if="tEvent.participation.status === 'invited'">
                            <div class="subtle-button slim tw-mr-2" :class="{'tw-opacity-50 tw-pointer-events-none': performing_action}" @click="decline">
                                {{ $t('groups.decline_invite') }}
                            </div>
                            <div class="general-button btn-v2" :class="{'tw-opacity-50 tw-pointer-events-none': performing_action}" @click="accept">
                                {{ $t('groups.accept_invite') }}
                            </div>
                        </template>
                    </template>
                    <div class="tw-flex tw-items-center">
                        <template v-if="isActiveParticipant">
                            <div class="tw-relative tw-flex tw-items-center" v-if="isInFuture || shouldShowWhenLive">
                                <div @click="openReminderMenu" class="subtle-button reminder-button tw-border tw-mr-2 event-notification tw-relative tw-border-gray-200 tw-hidden xs:tw-flex tw-items-center">
                                    <label class="tw-cursor-pointer tw-hidden xs:tw-flex xs:tw-items-center">
                                        <div class="checkbox-container">
                                            <input type="checkbox" ref="reminder" value="reminder" class="checkbox" disabled="disabled" :checked="reminders.length >= 1">
                                            <i class="fal fa-check checkbox-button"></i>
                                        </div>
                                        <span class="tw-font-semibold block tw-ml-2 tw-pl-2px tw-text-gray-400" ref="reminder_text" :class="{'secondary-c': reminders.length >= 1}">{{ $t('general.reminder') }}</span>
                                    </label>
                                </div>

                                <reminder-dropdown v-if="reminder_dropdown_open" :id="tEvent.id" type="event" :open="reminder_dropdown_open" @remindersChanged="handleRemindersChanged" @closeMenus="closeReminderMenus"/>
                            </div>

							<div class="general-button btn-v2" :class="{'tw-opacity-50 tw-pointer-events-none': performing_action}" @click="openPopup('invite_users')" v-if="(['moderator', 'founder'].includes(tEvent.participation.role) || $user.isModerator || tEvent.allow_user_invites === true) && !tEvent.live_room">
								{{ $t('groups.invite_users') }}
							</div>

							<template v-if="show_live_buttons">
								<router-link :to="{ name: 'liveroom', params: { event_slug: tEvent.slug } }"
								             target='_blank' @click.native="startStaging">
									<div class="general-button btn-v2"
									     :class="{ 'tw-opacity-50 tw-pointer-events-none': performing_action }"
									     v-if="tEvent.live_room.status === 'PLANNED'">
										<i class="far fa-video margin-0 tw-mr-2" />
										{{ $t('live.start_preparing') }}
									</div>
								</router-link>

								<router-link :to="{ name: 'liveroom', params: { event_slug: tEvent.slug } }"
											 target='_blank' @click.native="resumeRoom">
									<div class="general-button btn-v2"
										 :class="{ 'tw-opacity-50 tw-pointer-events-none': performing_action }"
										 v-if="tEvent.live_room.status === 'STAGING' || tEvent.live_room.status === 'STARTED'">
										<i class="far fa-video margin-0 tw-mr-2" />
										{{ $t('live.resume') }}
									</div>
								</router-link>
							</template>

							<clickable-icon tooltip="" class="tw-ml-3 xs:tw-hidden" v-if="['member'].includes(tEvent.participation.role) && !$user.isModerator && ((!$user.isModerator && tEvent.allow_user_invites === true) || ($user.isModerator && tEvent.allow_user_invites !== true) || tEvent.allow_user_invites !== true)" @clicked="openPopup('notification_reminder_event')">
								<i class="far fa-bell bell-reminder tw-text-xl" :class="reminders.length >= 1 ? 'secondary-c' : 'tw-text-dark'"></i>
							</clickable-icon>
						</template>

						<template v-if="isModerator || isFounder">
							<div class="tw-relative tw-flex tw-items-center">
								<clickable-icon class="tw-ml-3" @clicked="toggleActionsMenu">
									<i class="far fa-ellipsis-v tw-text-lg"></i>
								</clickable-icon>

                                <dropdown-menu v-if="actions_menu_open" @close="actions_menu_open = false" class="big">
                                    <dropdown-menu-item @click.native="handleInviteClick" class="tw-block md:tw-hidden" v-if="((tEvent.participation !== null && (['moderator', 'founder'].includes(tEvent.participation.role)) || $user.isModerator))">
                                        <i class="fal fa-plus"></i>
                                        {{ $t('groups.invite_users') }}
                                    </dropdown-menu-item>
                                    <dropdown-menu-item @click.native="handleReminderClick" class="tw-block xs:tw-hidden" v-if="tEvent.participation !== null && ((['moderator', 'founder'].includes(tEvent.participation.role)) || $user.isModerator)">
                                        <i class="fal fa-bell"></i>
                                        {{ $t('general.reminder') }}
                                        <i class="fal fa-check tw-pl-2 secondary-c" v-if="reminders.length >= 1"></i>
                                    </dropdown-menu-item>
                                    <dropdown-menu-item @click.native="handleEditClick">
                                        <i class="fal fa-cog"></i>
                                        {{ $t('fields.edit') }}
                                    </dropdown-menu-item>
                                    <dropdown-menu-item @click.native="handleLeaveClick" v-if="tEvent.participation !== null && tEvent.participation.status === 'active' && ['member', 'moderator'].includes(tEvent.participation.role)">
                                        <i class="fal fa-sign-out"></i>
                                        {{ $t('fields.leave') }}
                                    </dropdown-menu-item>
                                    <dropdown-menu-item @click.native="handleDisbandClick" v-if="isFounder || $user.isModerator">
                                        <i class="fal fa-trash"></i>
                                        {{ $t('fields.disband') }}
                                    </dropdown-menu-item>
                                </dropdown-menu>
                            </div>
                        </template>

						<clickable-icon tooltip="Exit event" class="tw-ml-3" v-if="tEvent.participation !== null && tEvent.participation.status === 'active' && ['member'].includes(tEvent.participation.role) && !$user.isModerator" @clicked="openPopup('leave_event')">
							<i class="far fa-sign-out tw-text-lg mimic-title"></i>
						</clickable-icon>
					</div>
				</div>
			</template>
		</tab-menu>

		<div class="main-content-inner-wrapper">
			<custom-form v-if="tEvent" class="tw-mt-0" :mainContent="true" :withStickyTabBar="true">
				<template v-if="current_tab === 'main' || current_tab === 'general'">
					<tab-general :tEvent="tEvent" :dateInfo="fullDateInfo" :isMember="isMember" @addDateToCalendar="openPopup('save_date')"></tab-general>
				</template>
				<template v-else-if="current_tab === 'members'">
					<tab-members :key="tEvent.id + '-show'" :model="tEvent" endpoint_name="events" :current_tab="current_tab" @inviteUsers="openPopup('invite_users')"></tab-members>
				</template>

				<template v-slot:sidebar>
					<template v-if="current_tab === 'main' || current_tab === 'general'">
						<sidebar-members :tEvent="tEvent" :members="members" :totalMemberPages="total_member_pages" v-if="members_loaded" @inviteUsers="openPopup('invite_users')"></sidebar-members>
						<sidebar-maps :tEvent="tEvent" v-if="!tEvent.online && tEvent.long !== '' && tEvent.lat !== ''"></sidebar-maps>
						<sidebar-trophy :trophy="tEvent.trophy" v-if="tEvent.trophy != null && plugins.gamification"></sidebar-trophy>
					</template>
					<template v-else-if="current_tab === 'members'">
						<sidebar-tab :title="$t('groups.invitations')" icon="mail-bulk" v-if="tEvent.participation !== null && (isModerator || isFounder)" :card_on_mobile="true" on_tab="members">
							<sidebar-pending :model_id="tEvent.id" endpoint_name="events" v-if="tEvent.status === 'private'"></sidebar-pending>
							<sidebar-invites :model_id="tEvent.id" endpoint_name="events"></sidebar-invites>
						</sidebar-tab>

						<sidebar-moderators :model_id="tEvent.id" endpoint_name="events"></sidebar-moderators>
					</template>
					<div></div>
				</template>
			</custom-form>
		</div>
	</div>
</template>

<script>
    import { mapState } from 'vuex';
    import axios from 'axios';
    import moment from 'moment';
    import Global from '../../mixins/Global';
    import Modal from '../../mixins/v2/Modal';
    import EventMixin from '../../mixins/v2/EventMixin';
    import EventHeader from '../../components/events/Header.vue';
    import HuddleEvent from '@/resources/assets/js/vue/lib/models/Event';
    import Reminder from '@/resources/assets/js/vue/lib/models/Reminder';
    import InviteUsersModal from '../../components/events_and_groups/InviteUsersModal.vue';
    import TabMenu from '../../mixins/v2/TabMenu';
    import TabGeneral from '../../components/events/tabs/General.vue';
    import SidebarMembers from '../../components/events/sidebar/SidebarMembers.vue';
    import Notification from '@/resources/assets/js/vue/lib/models/Notification';
    import SidebarTrophy from '@/resources/assets/js/vue/components/events/sidebar/SidebarTrophy';
    import SidebarMaps from '@/resources/assets/js/vue/components/events/sidebar/SidebarMaps';
    import TabMembers from '@/resources/assets/js/vue/components/events_and_groups/tabs/Members.vue';
    import SidebarModerators from '@/resources/assets/js/vue/components/events_and_groups/sidebar/SidebarModerators.vue';
    import SidebarPending from '../../components/events_and_groups/sidebar/SidebarPending.vue';
    import SidebarInvites from '../../components/events_and_groups/sidebar/SidebarInvites.vue';
    import { getParticipantToken, updateParticipant, updateRoomStatus } from "../../mixins/v2/LiveHelpers";
    import Room from "../../components/live/Room";
    import Countdown from "../../components/ui/Countdown";
    import ReminderModal from "../../components/ui/ReminderModal";
    import ReminderDropdown from "../../components/ui/ReminderDropdown";


export default {
	mixins: [
		Global,
		Modal,
		TabMenu,
		EventMixin,
	],

    components: {
        'countdown': Countdown,
        'event-header': EventHeader,
        'invite-users-modal': InviteUsersModal,
        'reminder-modal': ReminderModal,
        'reminder-dropdown': ReminderDropdown,
        'room': Room,
        'sidebar-members': SidebarMembers,
        'sidebar-trophy': SidebarTrophy,
        'sidebar-maps': SidebarMaps,
        'sidebar-moderators': SidebarModerators,
        'sidebar-pending': SidebarPending,
        'sidebar-invites': SidebarInvites,
        'tab-general': TabGeneral,
        'tab-members': TabMembers,
    },

    data() {
        return {
            debug: false,

            performing_action: false,
            members: [],
            members_loaded: false,
            total_member_pages: 1,
            actions_menu_open: false,
            notification_menu_open: false,
            reminders: [],
            reminder_dropdown_open: false,
            mount_reminder_modal: false,
            live_room_channel: null,
        };
    },

	computed: {
		...mapState([
			'plugins',
		]),
		apply_live_header_style() {
            return this.tEvent && this.tEvent.live_room && this.live_room_participant && !this.live_room_participant.room_admin;
		},

        show_live_room(){
            if(!this.tEvent || !this.tEvent.live_room || !this.live_room_participant) {
                return false;
            }
            return this.tEvent.type === 'live' && !this.live_room_participant.room_admin && this.tEvent.live_room.status === 'STARTED';
        },

		show_live_buttons() {
			return this.tEvent.live_room && this.live_room_participant && this.live_room_participant.room_admin;
		},

		tEvent() {
			return HuddleEvent.query().where('slug', this.$route.params.event_slug).first();
		},

		eventDateGoogle() {
			const event = HuddleEvent.query().where('slug', this.$route.params.event_slug).first();

			if (event === null) {
				return;
			}

			const start_date = moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('YYYYMMDD');
			let end_date = moment(event.end_date, 'MMMM DD, YYYY HH:mm').format('YYYYMMDD');
			const start_hour = moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('HH');
			const end_hour = moment(event.end_date, 'MMMM DD, YYYY HH:mm').format('HH');
			const start_minutes = moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('mm');
			const end_minutes = moment(event.end_date, 'MMMM DD, YYYY HH:mm').format('mm');
			const linkToEvent = this.replaceCharactersInString(window.location.href);
			const title = this.replaceCharactersInString(event.title);
			let location = '';

			if (!event.online && event.full_address !== undefined) {
				location = event.full_address.replace(/\s+/gm, '+');
			}

			if (event.all_day) {
				end_date = moment(end_date,'YYYYMMDD').add(1, 'days').format('YYYYMMDD');
				return `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${start_date}%2F${end_date}&details=${this.$t('events.more_info_event')}%20<a href="${linkToEvent}" target="_blank">${this.$route.params.event_slug}</a>&location=${location}&text=${title}`
			} else if (start_hour && end_hour) {
				return `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${start_date}T${start_hour}${start_minutes}00%2F${end_date}T${end_hour}${end_minutes}00&details=${this.$t('events.more_info_event')}%20<a href="${linkToEvent}" target="_blank">${this.$route.params.event_slug}</a>&location=${location}&text=${title}`
			}
		},

		eventDateOutlook() {
			const event = HuddleEvent.query().where('slug', this.$route.params.event_slug).first();

			if (event === null) {
				return;
			}

			const start_date = moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('YYYY-MM-DD');
			let end_date = moment(event.end_date, 'MMMM DD, YYYY HH:mm').format('YYYY-MM-DD');
			const start_hour = moment(moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('HH'), 'H').format('HH');
			const end_hour = moment(moment(event.end_date, 'MMMM DD, YYYY HH:mm').format('HH'), 'H').format('HH');
			const start_minutes = moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('mm');
			const end_minutes = moment(event.end_date, 'MMMM DD, YYYY HH:mm').format('mm');
			const title = this.replaceCharactersInString(event.title);
			const linkToEvent = this.replaceCharactersInString(window.location.href);
			let location = '';

			if (!event.online && event.full_address !== undefined) {
				location = event.full_address.replace(/\s+/gm, '+');
			}

			if (event.all_day) {
				end_date = moment(end_date,'YYYYMMDD').add(1, 'days').format('YYYY-MM-DD');
				return `https://outlook.live.com/calendar/0/deeplink/compose?body=${this.$t('events.more_info_event')}%20<a href="${linkToEvent}" target="_blank">${this.$route.params.event_slug}</a>&enddt=${end_date}&location=${location}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${start_date}&subject=${title}&allday=true`;
			} else {
				return `https://outlook.live.com/calendar/0/deeplink/compose?body=${this.$t('events.more_info_event')}%20<a href="${linkToEvent}" target="_blank">${this.$route.params.event_slug}</a>&enddt=${end_date}T${end_hour}%3A${end_minutes}%3A00&location=${location}&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=${start_date}T${start_hour}%3A${start_minutes}%3A00&subject=${title}`;
			}
		},

		tabs() {
			return [
				{
					name_clean: 'general',
					name: this.$t('general.general'),
					icon: 'far fa-info-circle',
					hide_on_mobile: false,
					default: true,
				},
				{
					name_clean: 'members',
					name: this.$t('events.participants'),
					icon: 'far fa-users',
					hide_on_mobile: false,
					default: false,
				},
			];
		},

		isActiveParticipant() {
			return this.tEvent &&
				this.tEvent.participation !== null &&
				this.tEvent.permissions.includes('VIEW') &&
				this.tEvent.participation.status === 'active' &&
				[['member', 'moderator', 'founder'].includes(this.tEvent.participation.role)];
		},

		isMember() {
			if (this.$user.isModerator ||
				(this.isActiveParticipant)) {
				return true;
			}

			return false;
		},

		isModerator() {
			return this.$user.isModerator || (this.isActiveParticipant && this.tEvent.participation.role === 'moderator' && this.tEvent.permissions.includes('EDIT'));
		},

		isFounder() {
			return this.isActiveParticipant && this.tEvent.participation.role === 'founder' && this.tEvent.permissions.includes('EDIT');
		},

		// i.e. thursday 07 january 2021 at 13:00 until firday 08 january 2021 at 14:00
		fullDateInfo() {
			const startDate = moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').format('DD MMMM YYYY');
			const endDate = moment(this.tEvent.end_date, 'MMMM DD, YYYY HH:mm').format('DD MMMM YYYY');

			return {
				startDay: moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').format('dddd'),
				startDate: startDate,
				startTime: moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').format('HH:mm'),
				endDay: moment(this.tEvent.end_date, 'MMMM DD, YYYY HH:mm').format('dddd'),
				endDate: endDate,
				endTime: moment(this.tEvent.end_date, 'MMMM DD, YYYY HH:mm').format('HH:mm'),
				endsOnSameDay: startDate === endDate,
			}
		},

		// i.e. thu 07-01-2021 at 13:00 until fri 08-01-2021 at 14:00
		shortDateInfo() {
			const startDate = moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').format('DD-MM-YYYY');
			const endDate = moment(this.tEvent.end_date, 'MMMM DD, YYYY HH:mm').format('DD-MM-YYYY');

			return {
				startDay: moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').format('ddd').slice(0, -1),
				startDate: startDate,
				startTime: moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').format('HH:mm'),
				endDay: moment(this.tEvent.end_date, 'MMMM DD, YYYY HH:mm').format('ddd').slice(0, -1),
				endDate: endDate,
				endTime: moment(this.tEvent.end_date, 'MMMM DD, YYYY HH:mm').format('HH:mm'),
				endsOnSameDay: startDate === endDate,
			}
		},

		isInFuture() {
			return moment(this.tEvent.start_date, 'MMMM DD, YYYY HH:mm').isAfter(moment());
		},

		shouldShowWhenLive(){
			return this.tEvent.live_room && (this.tEvent.live_room.status === 'PLANNED' || this.tEvent.live_room.status === 'STAGING');
		},

		live_room_participant() {
			if(!this.tEvent || this.tEvent.type !== 'live' || !this.tEvent.live_room || !this.tEvent.live_room.participants || !this.isActiveParticipant) return false;
            return this.tEvent.live_room.participants.find(p => p.user_id === this.user.id);
		},
	},

	watch: {
        tEvent(newEvent, oldEvent){
            if(newEvent !== oldEvent && this.tEvent.live_room && this.isActiveParticipant && this.live_room_participant){
                if(!this.live_room_channel){
                    this.setupPresenceChannel();
                }
            }
        }
	},

    methods: {
        handleInviteClick() {
            this.actions_menu_open = false;
            this.openPopup('invite_users');
        },

        handleReminderClick() {
            this.actions_menu_open = false;
            this.openReminderMenu();
        },

        handleEditClick() {
            this.actions_menu_open = false;
            this.navigateToEditPage();
        },

        handleLeaveClick() {
            this.actions_menu_open = false;
            this.openPopup('leave_event');
        },

        handleDisbandClick() {
            this.actions_menu_open = false;
            this.openPopup('disband_event');
        },

        async startStaging() {
            if(this.live_room_participant){
                const token = this.live_room_participant.access_token;
                const participantId = this.live_room_participant.id;
                await getParticipantToken(token, participantId);
                await updateRoomStatus("STAGING", this.tEvent.live_room.id);
            }
        },

		async resumeRoom() {
			if(this.live_room_participant){
				const token = this.live_room_participant.access_token;
				const participantId = this.live_room_participant.id;
				await getParticipantToken(token, participantId);
			}
		},

       async getEvent() {
            await HuddleEvent.api().fetchBySlug(this.$route.params.event_slug).then((resp) => {
                this.getMembers();
                Reminder.api().fetchAllReminders(this.tEvent.id, 'event').then((response) => {
                    this.reminders = response.response.data.data;
                });

                document.title = `${this.$t('events.plural')} | ${this.tEvent.title}`;
            });
		},

        handleRemindersChanged(reminders){
            this.reminders = reminders;
        },

        closeReminderMenus() {
            this.mount_reminder_modal = false;
            this.reminder_dropdown_open = false;
        },

        openReminderMenu() {
            const xs_breakpoint = '576'; // according to tailwind.config.js
            if(window.innerWidth >= xs_breakpoint) {
                this.reminder_dropdown_open = true;
            } else {
                this.mount_reminder_modal = true;
                this.openPopup('reminder_modal_mobile');
            }
        },

		join() {
			if (!this.performing_action) {
				this.performing_action = true;

				HuddleEvent.api().join(this.tEvent.id).then(async () => {
					this.tEvent.mine = true;

                    let pendingRequest = false;

                    if (this.tEvent.status !== "public" && !this.$user.isModerator && !this.$user.isAdmin) {
                        pendingRequest = true;
                    }

					if (!pendingRequest) {
						this.tEvent.participation = {
							status: 'active',
							role: 'member',
						};

						this.tEvent.members_count += 1;
						this.members.push({user, status: 'active'});

						this.getEventUrlsAfterAccess();

						Notification.insert({
							data: [
								{
									title: `${this.$t('events.you_are_signed_up')}!`,
								},
							],
						});

                        if(this.tEvent.live_room){
                            // fetch the event again because we need the latest live room participants
                            await this.getEvent();
                            if(!this.live_room_channel){
                                this.setupPresenceChannel();
                            }

                            if (this.tEvent.live_room.status === 'PLANNED') {
                              this.openPopup('save_date');
                            }
                        } else {
                          this.openPopup('save_date');
                        }
					} else {
						Notification.insert({
							data: [
								{
									title: `${this.$t('groups.request_to_join_sent')}.`,
								},
							],
						});

						this.tEvent.participation = {
							status: 'pending',
						};
					}

					this.performing_action = false;
				}).catch(() => {
					this.performing_action = false;

					Notification.insert({
						data: [
							{
								title: `${this.$t('events.singular')} ${this.$t('groups.could_no_be_joined')}.`,
								status: 'error',
							},
						],
					});
				});
			}
		},

		leave() {
			if (!this.performing_action) {
				this.performing_action = true;

				this.closePopup();
				this.$store.commit('toggleSpinner', true);

				HuddleEvent.api().leave(this.tEvent.id).then(() => {
					Notification.insert({
						data: [
							{
								title: this.tEvent.participation.status === 'pending' ? this.$t('groups_and_events.request_withdrawn') : `${this.$t('events.singular')} ${this.$t('groups.left')}.`,
							},
						],
					});

					this.tEvent.members_count -= 1;

					const member_index = this.members.findIndex(member => member.user.id === user.id);

					if (member_index !== -1) {
						this.members.splice(member_index, 1);
					}

					this.$store.commit('toggleSpinner', false);

					this.tEvent.participation = null;
					this.tEvent.mine = false;

					this.performing_action = false;

					this.deleteEventReminders(this.tEvent.id);

					if (this.tEvent.status === 'secret') {
						HuddleEvent.delete(this.tEvent.id);
					}

					this.$router.push(
						{
							name: 'events.index',
						}
					);
				}).catch(() => {
					this.performing_action = false;

					this.$store.commit('toggleSpinner', false);

					Notification.insert({
						data: [
							{
								title: this.tEvent.participation.status === 'pending' ? this.$t('groups_and_events.request_could_not_be_withdrawn') : `${this.$t('events.singular')} ${this.$t('groups.could_not_be_left')}.`,
								status: 'error',
							},
						],
					});
				});
			}
		},

		decline() {
			if (!this.performing_action) {
				this.performing_action = true;

				const status = 'declined';

				HuddleEvent.api().decline(this.tEvent, status).then(() => {
					this.tEvent.participation = {
						status: 'declined',
						role: 'member',
					};

					this.tEvent.invitation = {};

					this.performing_action = false;

					Notification.insert({
						data: [
							{
								title: `${this.$t('groups.invite_declined')}`,
							},
						],
					});

					this.$router.push(
						{
							name: 'events.index',
						},
					);
				}).catch(() => {
					this.performing_action = false;

					Notification.insert({
						data: [
							{
								title: `${this.$t('groups.Invite_could_not_be_declined')}`,
								status: 'error',
							},
						],
					});
				});
			}
		},

		accept() {
			if (!this.performing_action) {
				this.performing_action = true;

				HuddleEvent.api().accept(this.tEvent).then(() => {
					this.tEvent.participation = {
						status: 'active',
						role: 'member',
					};

					this.tEvent.members_count += 1;

					const member = this.members.find(member => member.user.id === user.id);

					if (typeof member !== 'undefined') {
						member.status = 'active';
					}

					this.performing_action = false;

					this.getEventUrlsAfterAccess();

					Notification.insert({
						data: [
							{
								title: `${this.$t('groups.invite_accepted')}`,
							},
						],
					});

					this.openPopup('save_date');
				}).catch((err) => {
					this.performing_action = false;

					Notification.insert({
						data: [
							{
								title: `${this.$t('groups.Invite_could_not_be_accepted')}`,
								status: 'error',
							},
						],
					});
				});
			}
		},

		// url and url_title are empty when you don't have access to the event, so we need to fetch those after joining the event so we can display them
		getEventUrlsAfterAccess() {
			axios.get(`/api/v3/events/${this.tEvent.id}`).then((response) => {
				this.tEvent.url = response.data.data.url;
				this.tEvent.url_title = response.data.data.url_title;
			}).catch(() => {});
		},

		toggleActionsMenu() {
			this.actions_menu_open = !this.actions_menu_open;
		},

        navigateToEditPage() {
            this.$router.push(
                {
                    name: 'events.edit',
                    params: {
                        event_slug: this.tEvent.slug,
                    }
                }
            );
        },

		getMembers() {
			axios.get(`/api/v3/events/${this.tEvent.id}/members?size=20&where=status:active`).then((users) => {
				this.total_member_pages = users.data.meta.last_page;
				this.members = users.data.data;
				this.members_loaded = true;
			});
		},

		deleteEvent() {
			this.closePopup();

			HuddleEvent.api().delete(`/api/v3/events/${this.tEvent.id}`, {
				delete: this.tEvent.id,
			}).then(() => {
				Notification.insert({
					data: [
						{
							title: `${this.$t('events.singular')} ${this.$t('general.deleted')}.`,
						},
					],
				});

				this.$router.push(
					{
						name: 'events.index',
					}
				);
			}).catch(() => {
				Notification.insert({
					data: [
						{
							title: `${this.$t('events.singular')} ${this.$t('groups.could_not_be_deleted')}.`,
							status: 'error',
						},
					],
				});
			});
		},

		replaceCharactersInString(string) {
			let formattedString = string.replace(/%/gm, '%25');
			formattedString = formattedString.replace(/&#39;/gm, "\'");
			formattedString = formattedString.replace(/&quot;/gm, '\"');
			formattedString = formattedString.replace(/&rsquo;/gm, '\'')
			formattedString = formattedString.replace(/&rsquo;/gm, '\'')
			formattedString = formattedString.replace(/&eacute;/gm, 'é')
			formattedString = formattedString.replace(/\+/, '%2B');
			formattedString = formattedString.replace(/(\s+|&nbsp;)/gm, '%20');
			formattedString = formattedString.replace(/&amp;/gm, '%26');
			formattedString = formattedString.replace(/&lt;/gm, '<');
			formattedString = formattedString.replace(/&gt;/gm, '>');
			formattedString = formattedString.replace(/\#/gm, '%23');

			return formattedString;
		},

		setupPresenceChannel() {
            this.live_room_channel = window.Echo.join(`live-room.${this.tEvent.live_room.id}`)
                .here(() => {
                    if (this.debug) { console.log("joined channel") }
                })

				// This event is not fired on the initiator side.
				.listen('.roomStatusUpdated', async (event) => {
                    if (this.debug) { console.log("roomStatusUpdated") }
                    await LiveRoom.update({
                        where: this.tEvent.live_room.id,
                        data: {
                            status: event.status,
                        }
                    });
                    this.tEvent.live_room.status = event.status;
				})

                .leaving((user) => {
                    if (this.debug) { console.log("left", user) }
                })

				.error((e) => {
					if (this.debug) alert(`Show.vue - setupPresenceChannel() - ${e}`);
				});
		},
    },

	mounted() {
		this.getEvent();
		this.fetchCategories();
	}
};
</script>

<style lang="scss" scoped>
  .webinar-card {
      margin: 0 auto;
      max-height: calc(100vh - 70px - 31px); // calc(100vh - navbar - indicating there is content under the card)
      max-width: 1320px;
      position: relative;
      background-color: lightskyblue;
      aspect-ratio: 16/9; // Doesn't work on IE 19/04/2022
  }

  .webinar-card > div {
      height: 100%;
      width: 100%;
      position: absolute;
  }

  #event-show {
      .action-btn-wrapper {
          .general-button {
              min-width: 150px;
              padding-top: 10px;
              padding-bottom: 10px;
          }

          .subtle-button {
              padding-top: 10px;
              padding-bottom: 10px;

              &.reminder-button {
                  padding-left: 16px;
                  padding-right: 16px;
              }
          }
      }

      .card-shadow, .compact-posts-wrapper {
          box-shadow: 0 1px 3px #00000029;
      }
  }

  .margin-0 {
      margin: 0 !important;
  }

  .checkbox-container {
      @apply tw-relative tw-cursor-pointer;
      width: 16px;
      height: 16px;
      margin-bottom: 0;
      padding-left: 0;

      .checkbox {
          position: absolute;
          opacity: 0;
          cursor: pointer;
          height: 0;
          width: 0;
          top: 0;

          &:checked {
              & ~ .checkbox-button {
                      &::before {
                          @apply tw-opacity-100;
                      }
              }
          }
      }

      .checkbox-button {
          @apply tw-w-full tw-h-full tw-border tw-border-gray-400 tw-font-medium tw-relative;
          border-radius: 3px;
          font-size: 11px;
          transition: border-color .15s;
          padding: 0 !important;
          margin: 0 !important;

          &::before {
              @apply tw-opacity-0 tw-absolute;
              top: 52%;
              left: 50%;
              transform: translate(-50%, -48%);
              transition: opacity .15s;
          }
      }
  }

  .bell-reminder {
      @apply tw-mt-px;
      transition: color .15s;
  }
</style>
